export default __webpack_public_path__ + "static/media/wingusecurity.871e95b1.png";